import {isEmbedded} from "../utilities/isEmbedded";

function useIsEmbedded(): boolean {
  return isEmbedded();
}

export default useIsEmbedded;
